
import { Prop } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import { ImportDataClient } from '@/services/Services';
import InfoModal from '@/components/modals/infoModal.vue';

@Options({})
export default class UploadFabricExcelModal extends Vue {

    file: File = null;

    @Prop() callback: any;

    created() {
    }

    uploadFile() {
        ImportDataClient.createCompanyFabricCompositionFromExcel(this.file)
        .then(x => {
            this.callback();
        })
        .catch(y => {
            this.$opModal.show(InfoModal, {
                text:this.$localizationService.getLocalizedValue("Error", "Error"),
                subtitle: y ? y : this.$localizationService.getLocalizedValue("Something went wrong", "Something went wrong"),
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => {
                    this.callback();
                }
            })
        })
    }

    goToGuide() {
        const routeData = this.$router.resolve({name: 'fabric-composition-excel-guide'});
        window.open(routeData.href, '_blank');
    }
    
}
